module.exports = __webpack_public_path__ + "kangping/img/2.ab8990f9.png";